<template>

  <div>

    <t-input-product-list v-if="mount" :show="modalSearch" :product-code-full="productCodeLabel"
                          @onClose="onModalSearchClose()" @onSelected="onSelected"/>


    <div class="d-flex align-items-start">

      <t-input @focusin="searchFocusIn" upper not-autocomplete @keyup.native="executeFastSearch"
               @focusout="searchFocusOut" :add-error="addError" :hide-label="hideLabel"
               :form-status="status" :form-command="command" :required="required" class-input="input-with-search"
               label="Produto"
               v-model="productCodeLabel">

        <template #input-group-append>

          <div style="position: absolute; left: -2px; top: 35px; background-color: #8b1833">

            <div tabindex="-1" :class="{'show':fastSearchList.length > 0}"
                 class="rm-pointers dropdown-menu dropdown-menu-left not-transform" style="min-width: 200px;">
              <!--              <h6 tabindex="-1" class="dropdown-header">
                              Busca
                            </h6>-->
              <button type="button" v-for="(item,index) in fastSearchList" :key="index" tabindex="0"
                      @click="setFastSearchByIndex(index)" :class="{'item-dropdown-select': index === fastSearchCursor}"
                      class="dropdown-item one-per-line">


                <div v-html="getDetailSearchList(item)"></div>

              </button>

              <!--
              <div tabindex="-1" class="dropdown-divider"></div>
           <h6 tabindex="-1" class="dropdown-header">Últimas pesquisas</h6>
              <button type="button" tabindex="0" class="dropdown-item active">
                Germany
              </button>
              <button type="button" tabindex="0" class="dropdown-item">
                Italy
              </button>-->
            </div>

          </div>

          <t-button icon-search outline-secondary
                    v-if="command === 'insert' || command === 'update'"
                    @click="openModalSearch()"/>
        </template>

      </t-input>

      <b-col class="text-left" v-if="!disableName" style="padding-right: 0px;" :style="{'margin-top': hideLabel ? '0px' : '22px'}">

        <div class="vs--disabled_label form-control" style="margin-bottom: 8px; text-overflow: ellipsis; overflow: hidden; height: 33px !important">
          <span>{{ name }}</span>
        </div>

      </b-col>

    </div>

  </div>

</template>
<script>
import tInputProductList from "@/components/template/form/finder/t-input-product-list";
import productService from "@/services/modules/product/Product.service";
import ui from "@/assets/scripts/ui";
import functionsMixins from "@/mixins/page/functionsMixins";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";

export default {
  name: 't-input-product',
  components: {tInputProductList},
  mixins: [functionsMixins],
  data() {
    return {
      path: "product", //Utilizar somente quando fora do padrão
      busy: false,
      productId: 0,
      productCodeLabel: "",
      name: "",
      enableFocusOutAction: true,
      onSending: false,
      mount: false,
      modalSearch: false,
      stopSearch: false,
      fastSearchCursor: -1,//Posição do cursor
      enableCloseFastSearch: true,//Trava fechamento da listagem para execução de alguma tarefa
      fastSearchList: [],
    }
  },
  props: {
    value: {
      type: null,
      default: ""
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    disableName: Boolean,
    addError: {
      type: String,
      default: ""
    },
    required: {/*ATENÇÃO PARA FUNCIONAR É NECESSÁRIO ENVIAR O STATUS E COMANDO*/
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: "",
    },
    command: {
      type: String,
      default: "insert",
    }
  },
  mounted() {
    this.getProductResume(this.value)
  },
  methods: {

    getDetailSearchList(item) {

      return "<div>" + ui.highlightSearch(item.productCodeLabel, this.productCodeLabel) + "</div><small>" + ui.highlightSearch(item.name, this.productCodeLabel) + "</small>"

    },

    onModalSearchClose() {
      this.modalSearch = false
    },

    onSelected(productId) {
      this.onModalSearchClose()
      this.$emit("input", productId)
    },

    openModalSearch() {

      document.activeElement.blur()

      this.modalSearch = true

      if (this.mount) {
        this.$bvModal.show('modal-product-search')
      } else {

        this.mount = true

        setTimeout(() => {
          this.$bvModal.show('modal-product-search')
        }, 200)

      }

    },

    async getProductResume(productId) {

      if (productId === 0) {
        this.productCodeLabel = ""
        this.name = ""
      } else {

        this.busy = true

        await this.getResumeProduct('id', productId).then(() => {
          this.setBlackout(false)
        })

      }

    },

    async setFastSearchByIndex(index) {


      this.productCodeLabel = this.fastSearchList[index].productCodeLabel
      this.enableFocusOutAction = false

      await this.getProductId()

      this.enableFocusOutAction = true


    },

    clearFastSearch() {
      this.fastSearchCursor = -1
      this.enableCloseFastSearch = true
      this.fastSearchList = []
    },

    executeFastSearch(event) {

      if (this.fastSearchList.length > 0 && !this.stopSearch) {

        if (event.which === 27) {
          //Parar de pesquisar e fechar

          this.stopSearch = true
          this.clearFastSearch()

        } else if (event.which === 38) {
          //Subir

          this.fastSearchCursor--;

          if (this.fastSearchCursor < 0) {
            //Não inicializado e será o último
            this.fastSearchCursor = this.fastSearchList.length - 1
          }

        } else if (event.which === 40) {
          //Descer

          this.fastSearchCursor++;

          if (this.fastSearchCursor > (this.fastSearchList.length - 1)) {
            //Não inicializado e será o último
            this.fastSearchCursor = 0
          }

        } else if (event.which === 13) {

          //Caso não selecionado, será subentendido o primeiro da lista
          if (this.fastSearchCursor < 0)
            this.fastSearchCursor = 0

          this.productCodeLabel = this.fastSearchList[this.fastSearchCursor].productCodeLabel

          setTimeout(() => {
            document.activeElement.blur()
          }, 50)


        } else {
          this.getFastSearchTop()
        }

      } else {
        this.getFastSearchTop()
      }

    },

    async getFastSearchTop() {

      if (!this.stopSearch) {
        if (this.productCodeLabel !== '') {

          let params = new URLSearchParams()
          params.set("default", this.productCodeLabel)
          params.set("top", "5")

          await crudGeneral.list(this.path + "/resumeTop", params)
              .then(list => {
                this.fastSearchList = list
              })
              .catch(error => {
                console.log('Erro externo: ' + error)
              })

        } else {
          this.clearFastSearch()
        }
      } else {

        if (this.productCodeLabel === '') {
          this.stopSearch = false
          this.clearFastSearch()
        }

      }


    },

    searchFocusIn() {

      //Desabilita o submit, caso existir para evitar que o produto ainda não tenha carregado ou esteja em alteração
      this.setDisabledButtonSubmit(true)

    },

    async searchFocusOut() {

      setTimeout(async () => {
        this.stopSearch = false
        this.clearFastSearch()

        if (this.enableFocusOutAction) {
          await this.getProductId()
        }

      }, 200)

    },

    async getProductId() {

      if (this.productCodeLabel === '') {
        this.productId = 0
      } else {
        await this.getResumeProduct('code', this.productCodeLabel)
      }

      this.$emit("input", this.productId)

      //Emite somente se for encontrado corretamente
      if (this.productId > 0)
        this.$emit("focusout", this.productId)

      //Saida do foco habilita novamente
      setTimeout(() => {
        //Tempo necessário para finalizar carregamento do produto
        this.setDisabledButtonSubmit(false)
      }, 500)

    },

    async getResumeProduct(type, param) {

      await productService.getResume(type, param).then(resume => {

        this.productId = resume.productId
        this.productCodeLabel = resume.productCodeLabel
        this.name = resume.name
        this.busy = false

        this.$emit("onResume",resume)

      }).catch(error => {

        if (error.response) {
          if (error.response.status === 500) {
            ui.msg(this, 'Informação', error.response.data.message)
          }
        } else if (error !== '') {
          ui.msg(this, "Erro", error)
        }
      })

    }

  },
  watch: {
    async value(v) {
      await this.getProductResume(v)
      this.$emit("change", v)
    },
    /*modalSearch(v) {

    }*/

  },
}
</script>